import { render, staticRenderFns } from "./BookBrochureware.vue?vue&type=template&id=685bbfe1"
import script from "./BookBrochureware.vue?vue&type=script&lang=js"
export * from "./BookBrochureware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StepsHorizontal: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/steps/horizontal/StepsHorizontal.vue').default,Book: require('/home/runner/work/platform/platform/packages/client/src/components/elements/book/book/Book.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
